<main class="container change-password-page">
  <div class="card card-register password-card">
    <h1 class="title">{{'change_password'|traduccion}}</h1>
    <p class="password-intro">{{'changePassword.description'|traduccion}}</p>
    <form class="register-form" [formGroup]="form" (ngSubmit)="changePassword()" [attr.aria-busy]="saving">
      @for (field of fields; track field.name) {
        <label [for]="field.name">{{field.label|traduccion}}</label>
        <div class="input-group form-group-no-border">
          <span class="input-group-text" aria-hidden="true"><i class="nc-icon nc-key-25"></i></span>
          <input [id]="field.name" [name]="field.name" [formControlName]="field.name"
            [type]="field.visible ? 'text' : 'password'" class="form-control"
            [placeholder]="field.label|traduccion" [autocomplete]="field.autocomplete" required
            [attr.aria-invalid]="fieldErrors(field.name).length > 0"
            [attr.aria-describedby]="field.name + '-errors'">
          <button type="button" class="input-group-text password-toggle" (click)="field.visible = !field.visible"
            [disabled]="saving" [attr.aria-pressed]="field.visible"
            [attr.aria-label]="(field.visible ? 'changePassword.hide' : 'changePassword.show')|traduccion">
            <mat-icon>{{field.visible ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </div>
        <div class="validation-errors" [id]="field.name + '-errors'" aria-live="polite">
          @for (error of fieldErrors(field.name); track error) {
            <small>{{error|traduccion}}</small>
          }
        </div>
        @if (field.name === 'newPassword') {
          <small class="password-hint">{{'changePassword.requirements'|traduccion}}</small>
          @if (passwordStrength > 0) {
            <div class="strength-track" role="progressbar" [attr.aria-label]="'changePassword.strength'|traduccion"
              aria-valuemin="0" aria-valuemax="5" [attr.aria-valuenow]="passwordStrength" [attr.aria-valuetext]="strengthLabel|traduccion">
              <div class="strength-fill" [style.width.%]="passwordStrength * 20"></div>
            </div>
            <small>{{strengthLabel|traduccion}}</small>
          }
        }
      }
      @if (failed) {
        <p class="validation-errors request-error" role="alert">{{'common.actionError'|traduccion}}</p>
      }
      <button type="submit" [disabled]="form.invalid || saving" class="btn btn-outline-neutral btn-block btn-round">
        @if (saving) {
          <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
        }
        {{(saving ? 'changePassword.saving' : 'change_password')|traduccion}}
      </button>
    </form>
  </div>
</main>
